import { css } from "@emotion/css";
import { Spacing } from "@snapchat/snap-design-system";

export const lensCtaContainer = css`
    margin-bottom: ${Spacing.MD}px;
`;
